<div fxLayout="column" class="neq-dialog">
    <div *ngIf="message" [innerHTML]="message"></div>

    <div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
      <button pButton class="neq-primeng-button-text"
              [label]="'msg.common.validation.ok' | translate" [mat-dialog-close]="true"></button>
      <button pButton class="neq-primeng-button-text"
              [label]="'msg.common.validation.cancel' | translate" [mat-dialog-close]="false"></button>
    </div>
</div>
